<template>
  <b-card>
    <app-timeline>
      <app-timeline-item
        v-for="(exercise, exerciseIndex) in exercises"
        :key="exerciseIndex"
        :num="exerciseIndex + 1"
      >
        <questions :exercise="exercise" :exerciseIndex="exerciseIndex" @getSession="$emit('getSession')" @getCourse="$emit('getCourse')" />
        <hr class="m-xl-2 m-0" v-if="exerciseIndex !== exercises.length - 1" />
      </app-timeline-item>
    </app-timeline>
    <!-- <b-overlay
      :show="showExercises"
      no-wrap
      variant="transparent"
      opacity="0.85"
      blur="2px"
      ><template #overlay>
        <div class="text-center">
          <b-button
            aria-describedby="cancel-label"
            @click="showExercises = false"
            variant="outline-primary"
          >
            شروع تمرین
          </b-button>
        </div>
      </template></b-overlay
    > -->
  </b-card>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BOverlay,
  BButton,
  BFormFile,
  BFormRadio,
} from "bootstrap-vue";
import Editor from "@core/components/editor/Editor.vue";
import Timer from "@core/components/timer/Timer.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import Questions from "./Questions.vue";
export default {
  components: {
    BCard,
    BFormGroup,
    BOverlay,
    BButton,
    BFormFile,
    BFormRadio,
    Editor,
    Timer,
    AppTimeline,
    AppTimelineItem,
    ValidationProvider,
    ValidationObserver,
    Questions,
  },
  props: {
    exercises: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      required,
      showExercises: true,
    };
  },
};
</script>

<style></style>
